<template>
  <select ref="select" :name="name">
    <!-- <option v-for="option in options" :value="option.id" :key="option.name" >{{option.text}}</option> -->
  </select>
</template>
  <!-- eslint-disable no-undef -->
<script>
export default {
  props: ["opts", "selectValue", "options", "name", "disabled"],
  data: function () {
    return {};
  },
  mounted: function () {


    this.$select
      // init select2
      .select2(this.initOptions)
      .val(null)
      .val(this.selectValue || "")
      .trigger("change")
      // emit event on change.
      .on("select2:select", this.emitChange)
      .on("select2:selecting", this.emitSelecting)
      .on("select2:unselect", this.emitUnselect)
      .on("select2:open", (e) => {
        const event = "scroll.select2";
        $(e.target).parents().off(event);
        $(window).off(event);
      });

    if (this.$select) this.$select.prop("disabled", this.disabled);
  },
  destroyed: function () {
    if (this.$select) this.$select.off().select2("destroy");
  },
  watch: {
    disabled: function (value) {
      if (this.$select) this.$select.prop("disabled", value);
    },
    opts: function () {
      // update options
      if (this.$select)
        this.$select
          .empty()
          .select2(this.initOptions)
          .val(this.selectValue || "")
          .trigger("change");
    },
    selectValue: function () {
      this.$select.val(this.selectValue).trigger("change");
    },
  },
  computed: {
    $select: function () {
      return $(this.$refs.select);
    },
    initOptions() {
      var finalOoptions = { data: this.opts };

      if (this.options) {
        const { wrapper, customWrapper } = this.options;

        if (customWrapper) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.options.dropdownParent = $(customWrapper);
        } else if (wrapper) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.options.dropdownParent = $(`#${wrapper}`);
        }

        finalOoptions = Object.assign(finalOoptions, this.options);
      }
      return finalOoptions;
    },
  },
  methods: {
    emitChange() {
      this.$emit("change", this.$select.val());
    },
    emitSelecting(evt) {
      this.$emit("selecting", evt);
    },
    emitUnselect() {
      this.$emit("change", this.$select.val());
      setTimeout(() => {
        $(".select2-in-modal").select2("close");
      }, 50);
    },
    select(val) {
      this.$select.val(val).trigger("change");
    },
    updateOptions(newOpts) {
      this.opts = newOpts;
      this.$nextTick(() => {
        $(this.$refs.select)
          .select2("destroy")
          .empty()
          .select2(this.initOptions);
        $(this.$refs.select).val(this.selectValue).trigger("change");
      });
    },
  },
};
</script>
